import { Bot, Building2, MessageSquare, Radar, Users } from 'lucide-react'
import { channelsLabel, formatCount } from './types'
import type { BroadcastChannels, Reach } from './types'

interface Props {
  reach: Reach
  channels: BroadcastChannels
}

interface TileProps {
  icon: React.ComponentType<{ className?: string }>
  label: string
  value: number
  hint?: string
  dimmed?: boolean
}

function Tile({ icon: Icon, label, value, hint, dimmed = false }: TileProps) {
  return (
    <div className="rounded-lg border border-border/60 bg-background px-3.5 py-3">
      <p className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
        <Icon className="h-3 w-3" />
        {label}
      </p>
      <p
        className={`mt-0.5 text-[22px] font-bold tabular-nums ${
          dimmed ? 'text-muted-foreground/60' : 'text-foreground'
        }`}
      >
        {formatCount(value)}
      </p>
      {hint && <p className="text-[11px] text-muted-foreground/70">{hint}</p>}
    </div>
  )
}

export default function ReachCard({ reach, channels }: Props) {
  const channelsOn = channels.panel || channels.email
  return (
    <section className="rounded-xl border border-border bg-card shadow-sm">
      <div className="px-5 pt-4">
        <h3 className="flex items-center gap-2 text-[15px] font-semibold text-foreground">
          <Radar className="h-4 w-4 text-muted-foreground" />
          Alcance do comunicado
        </h3>
        <p className="mt-0.5 text-xs text-muted-foreground">Atualiza conforme a seleção</p>
      </div>
      <div className="grid grid-cols-2 gap-2.5 p-5 pt-4">
        <Tile icon={Building2} label="Organizações" value={reach.orgs} />
        <Tile icon={Bot} label="Agentes" value={reach.agents} hint="canal padrão" />
        <Tile
          icon={MessageSquare}
          label="Sessões atingidas"
          value={reach.sessions}
          hint="sessões de usuário + principal de cada agente"
        />
        <Tile
          icon={Users}
          label="Usuários"
          value={reach.users}
          hint={channelsOn ? channelsLabel(channels) : 'sem canais adicionais'}
          dimmed={!channelsOn}
        />
      </div>
    </section>
  )
}
